// Packages
import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";

// Material Ui
import { Snackbar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { Animation } from "@devexpress/dx-react-chart";
import vdoIcon from "../../assets/images/vdoIcon.png";
import Popover from "@material-ui/core/Popover";
// Styles
import "./superAdmin.css";

// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";

// Assets
import { Chart, PieSeries } from "@devexpress/dx-react-chart-material-ui";
import PaymentHistoryTable from "../../Common/PaymentHistoryTable";
import SchoolStatus from "../schoolAdminPortal/SchoolAdminPages/SchoolStatus/SchoolStatus";
import DeleteIcon from "@mui/icons-material/Delete";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RestoreIcon from "@mui/icons-material/Restore";
import blankProfile from "../schoolAdminPortal/images/blank-profile.png";
import { openConfirmationPopup } from "../../Redux/Actions/PopupActions";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedSchoolInformation } from "../../Redux/Actions/SuperAdminDashboardActions";
import { ContentLayoutSpinner } from "../spinner/ContentLayoutSpinner";
import ContentLayoutDetailsHeader from "../../Common/ContentLayoutDetailsHeader";
import { AiFillSetting } from "react-icons/ai";
import { MdModeEdit } from "react-icons/md";
import SettingsPopup from "../../Common/SettingsPopup";
// Utils

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  typography: {
    padding: theme.spacing(2),
  },
}));

function SchoolNameScreen() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(0);
  const [snakBarStatus, setSnackbarStatus] = useState(false);
  const params = useParams();
  const school = document.getElementById("School");
  const schoolData = useSelector(
    (state) => state.SuperAdminDashboardData?.schoolData
  );
  const submitting = useSelector(
    (state) => state.SuperAdminDashboardData?.loading
  );
  const history = useHistory();
  const dispatch = useDispatch();
  if (school) {
    school.classList.add("active");
  }

  useEffect(() => {
    getSchoolDetailsById();
    if (params.storageId) {
      handleChange(2);
    }
  }, [params.schoolId]);

  const getSchoolDetailsById = () => {
    setSelectedSchoolInformation(dispatch, { schoolId: params.schoolId });
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarStatus(false);
  };

  const menuItemContent = (data) => {
    const nonDeleted = [
      {
        id: 1,
        name: "Delete School",
        icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
        apiToCall: handleDelete,
      },
      {
        id: 2,
        name: "Reset Password",
        icon: <VpnKeyIcon className="manage-section-iconss" />,
        apiToCall: handleReset,
      },
      {
        id: 3,
        name: data.status ? "Deactivate School" : "Activate School",
        icon: data.status ? (
          <DoDisturbOnIcon className="manage-section-iconss" />
        ) : (
          <CheckCircleIcon className="manage-section-iconss" />
        ),
        apiToCall: handleActivateDeactivateSchool,
      },
    ];

    const deleted = [
      {
        id: 1,
        name: "Recover School",
        icon: <RestoreIcon className="manage-section-iconss" />,
        apiToCall: handleRestore,
      },
    ];
    return !data.user?.deleted ? nonDeleted : deleted;
  };

  const handleRestore = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure You Want To Retore This School?",
        btnColor: "green",
        btnText: "Yes",
        id: schoolData?.id,
        type: "School Restore",
      },
    });
  };

  const handleReset = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure You Want To Reset The Password?",
        btnColor: "green",
        btnText: "Yes",
        email: schoolData?.email,
        type: "Reset Password",
      },
    });
  };

  const handleDelete = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure You Want To Delete This School?",
        btnColor: "red",
        btnText: "Yes",
        id: schoolData?.id,
        type: "School Delete",
      },
    });
  };

  const handleActivateDeactivateSchool = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: `Are You Sure You Want To ${
          schoolData?.status ? "Deactivate" : "Activate"
        } This School?`,
        btnColor: "red",
        btnText: "Yes",
        id: schoolData?.id,
        status: schoolData?.status,
        type: "School Activate / Deactivate",
      },
    });
  };

  const chartdata = [
    { storageType: "free", area: schoolData?.storage?.totalDuration },
    {
      storageType: "occupied",
      area: schoolData?.storage?.usedDuration.toFixed(2),
    },
  ];

  const settingList = () => {
    let menuList = [];
    switch (true) {
      case schoolData?.user?.deleted === true:
        menuList = [
          {
            id: 1,
            name: "Recover School",
            icon: <RestoreIcon className="manage-section-iconss" />,
            handleSubmit:
              schoolData?.user?.isFirstTime === false
                ? handleRestore
                : handleReset,
          },
        ];
        break;

      case schoolData?.user?.isFirstTime === true ||
        schoolData?.status === false:
        menuList = [
          {
            id: 1,
            name: "Delete School",
            icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
            handleSubmit: handleDelete,
          },
          {
            id: 3,
            name: schoolData?.status ? "Deactivate School" : "Activate School",
            icon: schoolData?.user?.active ? (
              <DoDisturbOnIcon className="manage-section-iconss activateSchool" />
            ) : (
              <CheckCircleIcon className="manage-section-iconss" />
            ),
            handleSubmit: handleActivateDeactivateSchool,
          },
        ];
        break;

      default:
        menuList = [
          {
            id: 1,
            name: "Delete School",
            icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
            handleSubmit: handleDelete,
          },
          {
            id: 2,
            name: "Reset Password",
            icon: <VpnKeyIcon className="manage-section-iconss" />,
            handleSubmit: handleReset,
          },
          {
            id: 3,
            name: schoolData?.status ? "Deactivate School" : "Activate School",
            icon: schoolData?.user?.active ? (
              <DoDisturbOnIcon className="manage-section-iconss deactivateSchool" />
            ) : (
              <CheckCircleIcon className="manage-section-iconss" />
            ),
            handleSubmit: handleActivateDeactivateSchool,
          },
        ];
    }
    return menuList;
  };

  const headerIcons = [
    {
      id: 1,
      icon: <MdModeEdit className="header-icon" />,
      handleClick: () => history.push(`/editschooldetails/${schoolData?.id}`),
    },
    {
      id: 2,
      icon: <AiFillSetting className="header-icon" />,
      handleClick: handleClick,
    },
  ];

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className="content-layout add-sectionn pt-10 position-relative">
      <SuperAdminDashboard />
      <ContentLayoutSpinner animate={submitting} />
      <ContentLayoutDetailsHeader
        label="School"
        name={schoolData?.schoolName}
        navigationLink="/schools"
        iconList={headerIcons}
      />
      <div className="">
        {/* light-grey-border */}
        <div className="d-flex-space-between pd-20 flex-wrap">
          <div className="d-flex-align-cent gap-20">
            <img
              className="details-profile img-fluid"
              src={
                schoolData?.uploadedLogo?.filePath
                  ? schoolData?.uploadedLogo?.filePath
                  : blankProfile
              }
              alt="PIC"
            />
            <div>
              <h4 className="fs-30 bold athlete-nm">
                {schoolData?.schoolName}
              </h4>
            </div>
            <SchoolStatus
              status={schoolData?.status}
              isDeleted={schoolData?.user && schoolData?.user?.deleted}
            />
          </div>
          <div className="d-flex-center gap-10">
            <div id="hoverCard">
              <div className="txt-center">
                <div className="number-card border-grey">
                  <label className="fs-30 bold pd-0">
                    {schoolData?.coachesCount}
                  </label>
                  <p className="fs-16 semi-bold">Coaches</p>
                </div>
              </div>
            </div>

            <div id="hoverCard">
              <div className="txt-center">
                <div className="number-card border-grey">
                  <label className="fs-30 bold pd-0">
                    {schoolData?.athletesCount}
                  </label>
                  <p className="fs-16 semi-bold">Athletes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.root} id="tabs">
          <AppBar position="static" color="default">
            <div className="bgwhite">
              <Tabs
                className="txt-blue bold  setting-route"
                value={value}
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                <Tab
                  label="SCHOOL INFO."
                  {...a11yProps(0)}
                  onClick={() => handleChange(0)}
                />
                <Tab
                  label="PAYMENTS"
                  {...a11yProps(1)}
                  onClick={() => handleChange(1)}
                />
                <Tab
                  label="STORAGE"
                  {...a11yProps(2)}
                  onClick={() => handleChange(2)}
                />
              </Tabs>
            </div>
          </AppBar>
          <TabPanel className="px-3 pt-3" value={value} index={0}>
            <>
              <div className="col-12 col-lg-7 col-md-12 white-card plr d-flex-align-cent pd-5">
                <p className="small-btn profile-image-label">Profile Image</p>
                <div className="circular profile-img">
                  <img
                    className=" img-fluid "
                    src={
                      schoolData?.user?.profileUrl?.filePath
                        ? schoolData?.user?.profileUrl?.filePath
                        : blankProfile
                    }
                    alt="Your Profile Image"
                  />
                </div>
                <div className="mg-left-10">
                  <span className="fs-22 black  semi-bold">
                    {schoolData?.user?.firstName} {schoolData?.user?.lastName}
                  </span>
                </div>
              </div>
              <div className="clear30"></div>
              <div className="col-12 col-lg-7 col-md-12 white-card plr pt-1">
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>First Name</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.firstName}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>Last Name</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.lastName}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>Email</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.email}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>Phone Number</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.phoneNumber}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>Country</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.country}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>State</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.state}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>School Name</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.schoolName}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label className="fs-18 ">School Type</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.schoolType}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>Sports</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.sport}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>PlayLevel</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>
                      {schoolData?.playLevel == null
                        ? "-"
                        : schoolData?.playLevel}
                    </p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>Plan</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{schoolData?.plan == null ? "-" : schoolData?.plan}</p>
                  </div>
                </div>
                <div className="clear10"></div>
              </div>
              <div className="clear30"></div>
              <div className="col-12 col-lg-7 col-md-12 white-card w-100 plr pt-1">
                <div className="clear10"></div>
                <div className="row p-1">
                  <label className="fs-20 bold">OTHER DETAILS</label>
                </div>
                <div className="clear10"></div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>Date Joined</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{moment(schoolData?.createdAt).format("MM/DD/YYYY")}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>Any Message</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>
                      {schoolData?.anyMessage ? schoolData?.anyMessage : "-"}
                    </p>
                  </div>
                </div>
                <div className="clear10"></div>
              </div>
              <div className="clear20"></div>
            </>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 pr-1 pl-1">
              <PaymentHistoryTable />
            </div>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <div>
              <div className="row mt-2">
                <div className="col-12 col-md-12 col-lg-6 rightBorder-grey">
                  <div className="row">
                    <div className="col-7 col-lg-8" id="chartstyle">
                      <Chart data={chartdata}>
                        <PieSeries
                          valueField="area"
                          argumentField="storageType"
                        />
                        <Animation />
                      </Chart>
                      <div className="w-100">
                        <div className="">
                          <p className="txt-center txt-blue semi-bold fs-16">
                            {schoolData?.storage?.usedDuration.toFixed(2)} hours
                            used of {schoolData?.storage?.totalDuration} hours
                          </p>
                        </div>
                        {schoolData?.upgradedAt && (
                          <div>
                            <p className="txt-center txt-blue semi-bold fs-16">
                              Storage Upgraded At :{" "}
                              {moment(schoolData?.upgradedAt).format(
                                "MM/DD/YYYY"
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-5 col-lg-4">
                      <label>Storage Overview</label>
                      <div className="d-flex ">
                        <div className=" ">
                          <div className="freeStorage"></div>
                        </div>
                        <div className="txtlightgrey mx-2">
                          <label>Free</label>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="">
                          <div className="occupiedStorage"></div>
                        </div>
                        <div className="txtlightgrey mx-2">
                          <label>Occupied</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Snackbar
                  id="snackbar"
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={snakBarStatus}
                  autoHideDuration={3000}
                  onClose={handleCloseSnack}
                  ContentProps={{
                    "aria-describedby": "message-id",
                  }}
                  message={<span id="message-id">School status updated.</span>}
                  action={[]}
                />

                <div className="col-12 col-md-12 col-lg-6 mt-2">
                  <div className="row fs-16 mg-bottom-10">
                    <div className="col-8">
                      <div className="row">
                        <div className="col-1"></div>
                        <div className="col-2 mr-4">
                          <label>
                            <img src={vdoIcon} alt="" />
                          </label>
                        </div>
                        <div className="col-6 p-0">
                          <div>Videos</div>
                          <div className="txtlightgrey">
                            {schoolData?.uploadedVideosCount} files
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      <p className="txt-center storagewhite-box">
                        {schoolData?.storage?.usedDuration.toFixed(2)} Hours
                      </p>
                    </div>
                  </div>
                  <hr></hr>
                </div>
              </div>
            </div>
          </TabPanel>
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <SettingsPopup settingList={settingList()} />
      </Popover>
    </div>
  );
}

export default SchoolNameScreen;
